/**
 * Simple utility function to sleep for a given amount of time in milliseconds.
 */

export default function sleep(ms: number) {
  return new Promise((r) => setTimeout(r, ms));
}
